document.addEventListener('DOMContentLoaded', () => {
  function initAccordions() {
    document.querySelectorAll('[data-accordion-group]').forEach(accordionGroup => {
      const accordionItems = accordionGroup.querySelectorAll('[data-accordion]');
      const accordionGroupId = accordionGroup.getAttribute('data-accordion-group-id');

      accordionItems.forEach((currentAccordionItem, index) => {
        const accordionHeader = currentAccordionItem.querySelector('[data-accordion-toggler]');
        const accordionContent = currentAccordionItem.querySelector('[data-accordion-content]');
        const imageIndex = currentAccordionItem.getAttribute('data-image-index');
        const tileId = currentAccordionItem.getAttribute('data-tile');
        const isFirstItem = index === 0;

        // Expand and fade-in accordion content
        const expandAccordion = () => {
          accordionContent.classList.remove('hidden');
          setTimeout(() => {
            accordionContent.style.height = accordionContent.scrollHeight + 'px';
            accordionContent.style.opacity = '1';
          }, 10);
          accordionHeader.classList.add('opened');
          accordionHeader.classList.remove('closed');
        };

        // Setup first item as open
        if (isFirstItem) {
          expandAccordion();

          if (imageIndex !== null) {
            const activeImage = document.getElementById(`${accordionGroupId}-accordion-image-${imageIndex}`);
            if (activeImage) activeImage.classList.add('active');
          }

          if (tileId) {
            const activeTile = document.getElementById(tileId);
            if (activeTile) activeTile.classList.add('active');
          }
        }

        // Click handler for accordion header
        accordionHeader.addEventListener('click', () => {
          const isAlreadyOpen = accordionHeader.classList.contains('opened');

          accordionGroup.querySelectorAll('[data-accordion]').forEach(otherAccordionItem => {
            const otherHeader = otherAccordionItem.querySelector('[data-accordion-toggler]');
            const otherContent = otherAccordionItem.querySelector('[data-accordion-content]');
            const otherImageIndex = otherAccordionItem.getAttribute('data-image-index');
            const otherTileId = otherAccordionItem.getAttribute('data-tile');

            const isNotCurrent = otherHeader !== accordionHeader;

            if (isNotCurrent && otherHeader.classList.contains('opened')) {
              // Collapse other item
              otherContent.style.height = otherContent.scrollHeight + 'px';
              otherContent.style.opacity = '1';
              setTimeout(() => {
                otherContent.style.height = '0px';
                otherContent.style.opacity = '0';
              }, 10);
              otherHeader.classList.remove('opened');
              otherHeader.classList.add('closed');
              setTimeout(() => otherContent.classList.add('hidden'), 300);

              // Deactivate image if any
              if (otherImageIndex !== null) {
                const otherImage = document.getElementById(`${accordionGroupId}-accordion-image-${otherImageIndex}`);
                if (otherImage) otherImage.classList.remove('active');
              }

              // Deactivate tile if any
              if (otherTileId) {
                const otherTile = document.getElementById(otherTileId);
                if (otherTile) otherTile.classList.remove('active');
              }
            }
          });

          // Open clicked item if it was closed
          if (!isAlreadyOpen) {
            expandAccordion();

            // Activate associated image
            if (imageIndex !== null) {
              const image = document.getElementById(`${accordionGroupId}-accordion-image-${imageIndex}`);
              if (image) image.classList.add('active');
            }

            // Activate associated tile
            if (tileId) {
              const tile = document.getElementById(tileId);
              if (tile) tile.classList.add('active');
            }
          }
        });
      });
    });
  }

  initAccordions();

  // Make sure image is not cropped
  document.querySelectorAll('.accordion-item__image-mobile img').forEach(img => {
    if (img.complete) {
      recalculateOpenAccordion();
    } else {
      img.addEventListener('load', () => {
        recalculateOpenAccordion();
      });
    }
  });

  function recalculateOpenAccordion() {
    document.querySelectorAll('[data-accordion-group]').forEach(accordionGroup => {
      const openAccordion = accordionGroup.querySelector('[data-accordion] [data-accordion-toggler].opened');
      if (openAccordion) {
        const content = openAccordion.closest('[data-accordion]').querySelector('[data-accordion-content]');
        if (content) {
          content.style.height = 'auto';
          const newHeight = content.scrollHeight;
          content.style.height = newHeight + 'px';
        }
      }
    });
  }
});